import { CONSTRUCTIONS1026_RESULTS } from "../actions/ActionType";

export const initialState = {
  types: []
};
export const constructions1026Reducer = (type = initialState, action) => {
  switch (action.type) {
    case CONSTRUCTIONS1026_RESULTS:
      return {
        constructions1026: action.payload
      };
    default:
      return type;
  }
};
